<div class="m-portlet m-portlet--creative m-portlet--first m-portlet--bordered-semi">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                    <i class="{{iconsClass}}"></i>
                </span>
                <h3 class="m-portlet__head-text">
                    <div class="mybox_desc">
                        <p *ngFor="let p of description.split('#')">{{p}}</p>
                    </div>
                </h3>
                <h2 class="m-portlet__head-label m-portlet__head-label--{{colorClass}}">
                    <span><i class="{{iconsClass}}"></i>&nbsp;{{boxTitle}}</span>
                </h2>
            </div>
        </div>
    </div>
    <div class="m-portlet__body m-stack m-stack--hor m-stack--general m-stack--demo">
        <div class="m-stack__item m-stack__item--center">
            <button routerLink="{{boxLink}}" type="button"
                class="btn m-btn--square btn-{{colorClass}}">GO&nbsp;&nbsp;&nbsp;<i class="fa fa-angle-right"
                    aria-hidden="true"></i></button>
        </div>
    </div>
</div>
<style type="text/css">
    .mybox_desc {
        width: 100%;
        min-height: 95px;
    }

    @media (min-width:991px) and (max-width:1234px) {
        .mybox_desc {
            min-height: 180px;
        }
    }

    @media (min-width:1235px) and (max-width:1520px) {
        .mybox_desc {
            min-height: 165px;
        }
    }

    @media (min-width:1521px) and (max-width:1650px) {
        .mybox_desc {
            min-height: 120px;
        }
    }
</style>